export const grey = '#d5d7e1';
export const beige = '#e1d7d5';
